import { Form, Formik, FormikHelpers } from 'formik';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import { SELECT_FIELD_DEFAULT_VALUE } from '../../../constants/settings';
import { SelectData } from '../../../types/common';
import AcademiaButton from '../Buttons/AcademiaButton';
import AcademiaFormSelect from '../Inputs/AcademiaFormSelect';
import AcademiaTextAreaField from '../Inputs/AcademiaTextAreaField';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const CreateEditReminderModal = ({
  title,
  handleModalClose,
}: {
  title: 'create' | 'update';
  handleModalClose: () => void;
}) => {
  // integration of react hooks here
  const [selectedClient, setSelectedClient] = useState<SelectData>(
    SELECT_FIELD_DEFAULT_VALUE
  );
  const [selectedAssociate, setSelectedAssociate] = useState<SelectData>(
    SELECT_FIELD_DEFAULT_VALUE
  );

  // handler function to handle create/edit reminder feature here
  const createEditReminderHandler = async (
    values: any,
    actions: FormikHelpers<any>
  ) => {
    try {
      actions.setSubmitting(true);

      console.log('REMINDER BODY: ', values);
    } catch (error) {
    } finally {
      actions.setSubmitting(false);
    }
  };

  // rendering create/edit reminder modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <ModalTitle titleText={`${title} reminder`} />

      <Formik
        initialValues={{ associate: '', client: '', message: '' }}
        onSubmit={createEditReminderHandler}
      >
        {(props) => (
          <Form className='space-y-5'>
            <AcademiaFormSelect
              options={[
                { id: 0, name: 'Client 1' },
                { id: 1, name: 'Client 2' },
              ]}
              name='client'
              label='Select Client'
              defaultValue={selectedClient}
              setValueOnChange={(value) => setSelectedClient(value)}
              isRequired
            />

            <AcademiaFormSelect
              options={[
                { id: 0, name: 'Associate 1' },
                { id: 1, name: 'Associate 2' },
              ]}
              name='associate'
              label='Select Associate'
              defaultValue={selectedAssociate}
              setValueOnChange={(value) => setSelectedAssociate(value)}
              isRequired
            />

            <AcademiaTextAreaField
              name='message'
              label='Message'
              placeholder='Enter message here...'
              isRequired
            />

            <div>
              <AcademiaButton
                type='submit'
                variant='premium'
                icon={<TbSquareRoundedPlusFilled className='size-6' />}
                isLoading={props.isSubmitting}
                fullWidth
              >
                Create Reminder
              </AcademiaButton>
            </div>
          </Form>
        )}
      </Formik>
    </ParentModal>
  );
};

export default CreateEditReminderModal;
